import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App.tsx';
import './index.css';
import { THEME_STORAGE_KEY } from './context/ThemeContext.tsx';
import { queryClient } from './lib/queryClient.ts';

// autoUpdate service worker (BUILD-SPEC §5-B): shell/assets are precached,
// every /api/* call stays NetworkOnly so finance data is never stale.
registerSW({ immediate: true });

// Apply the persisted theme before React mounts (no inline <script>, CSP-safe)
// so there's no flash of the wrong theme; ThemeProvider re-applies the same
// class once mounted. Default: light.
document.documentElement.classList.toggle(
  'dark',
  window.localStorage.getItem(THEME_STORAGE_KEY) === 'dark',
);

const el = document.getElementById('root');
if (!el) {
  throw new Error('Root-Element #root wurde nicht gefunden.');
}

createRoot(el).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
